/**
 * @module Services/Bff/Presenters/Request/ComboItemUpdate
 * @desc Combo Request Presenter
 *
 */

import type { Combo, SelectedComboProducts } from 'core/domains';

/**
 * Send the combo itemadd or update request payload
 *
 */
export function comboPostPresenter(payload: Combo['data']) {
  if (!Object.keys(payload).length) {
    return undefined;
  }

  const { choices, comboCode, quantity } = payload;

  const selectedItems: SelectedComboProducts['productsKitChoice'] = [];

  choices.forEach(({ items, structureCode }) =>
    items
      .filter((option) => option.quantity > 0)
      .map((option) =>
        selectedItems.push({
          quantity: option.quantity,
          structureCode,
          sku: option.code,
        }),
      ),
  );

  return {
    productsKitChoice: selectedItems,
    quantity,
    sku: comboCode,
  };
}
